let httpList = [
  {
    //登录接口
    url: '/fbUser/doLogin',
    name: 'doLogin',
  },
  {
    url: '/official/copy',
    name: 'copy',
  },
  {
    url: '/quote',
    name: 'quote',
  },
  {
    url: '/official/quoteInit',
    name: 'quoteInit',
  },
  {
    url: '/renewal',
    name: 'renewal',
  },
  {
    // 请求上年报价方案
    url: '/queryCoverQuote',
    name: 'queryCoverQuote',
  },
  {
    // 折旧
    url: '/officialDepreciation',
    name: 'officialDepreciation',
  },
  {
    // 地方税务机关查询
    url: '/official/queryVhlTaxRelief',
    name: 'queryVhlTaxRelief',
  },
  {
    // 车型查询
    url: '/officialVehicleModel',
    name: 'officialVehicleModel',
  },
  {
    // 大连辽宁机构查车
    url: '/mergerVehicleModel',
    name: 'mergerVehicleModel',
  },
  {
    // 保存流程数据
    url: '/officialApply',
    name: 'officialApply',
  },
  {
    // 提核前数据交互
    url: '/official/supplement',
    name: 'supplement',
  },
  // 提核
  {
    url: '/official/submitOrder',
    name: 'submitOrder',
  },
  //ocr
  {
    url: '/ocrHandle',
    name: 'ocrHandle',
  },
   // 新ocr，上传行驶证接口
   {
    url: '/vehicleLicenseOcr',
    name: 'vehicleLicenseOcr'
  },
  // 新ocr，上传身份证接口
  {
    url: '/idCardOcr',
    name: 'idCardOcr'
  },
  // 影响上传
  {
    url: process.env.VUE_APP_UPLOAD,
    name: 'haupload',
  },
  // 影响确认上传
  {
    url: '/official/imgUploadServer',
    name: 'imgUploadServer',
  },
  // 验车码
  {
    url: '/officialQueryCheckCode',
    name: 'officialQueryCheckCode',
  },
  // 获取用户车辆信息
  {
    url: process.env.VUE_APP_USERCNETER_API_URL + '/carInfo/userCarInfo',
    name: 'userCarInfo',
    config: {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded','X-Desensitize': false },
    },
  },
  // 添加埋点记录
  {
    url: process.env.VUE_APP_USERCNETER_API_URL + '/record/addRecord',
    name: 'addRecord',
    config: {
      headers: { 'Content-Type': 'application/json;charset=UTF-8','X-Desensitize': false },
    },
  },
  {
    url: '/switch/getAllSwitch',
    name: 'getAllSwitch',
  },
  // 获取职业范围列表
  {
    url: '/queryOccupationTypeConfig',
    name: 'queryOccupationTypeConfig',
  },
  // 获取新职业范围列表
  {
    url: '/official/queryCareerTypeList',
    name: 'queryCareerTypeList',
  },
  // 获取行业范围列表
  {
    url: '/official/queryBusinessMainConfig',
    name: 'queryBusinessMainConfig',
  },
  // 获取销售公司名称
  {
    url: '/official/queryTempSalesCompany',
    name: 'queryTempSalesCompany',
  },
  // 请求电子签名接口
  {
    url: '/official/queryEleSms',
    name: 'queryEleSms',
  },
  {
    url: '/h5Image/outside/queryToken', //影像token接口
    name: 'getImageToken',
  },
  // 更新影像状态
  {
    url: '/h5Image/outside/updateStatus',
    name: 'updateImgStatus',
  },
  // 订单详情接口
  {
    url: '/outside/orderDetail',
    name: 'getOrderDetail',
  },
  // 险别默认保额接口
  {
    url: '/outside/queryAutoRiskQuotaLimitList',
    name: 'queryAutoRiskQuotaLimitList'
  },
  // 新车录牌保单列表（非车接口）
  {
    url: '/fc/nsp-uwci/policyInfoCar',
    name: 'policyInfoCar'
  },
  // 新车录牌修改车牌
  {
    url: '/endorse/outside/endorByLicenseNo',
    name: 'endorByLicenseNo'
  },
   // 新车录牌提核
  {
    url: '/endorse/outside/endorByLicenseNoApprover',
    name: 'endorByLicenseNoApprover'
  },
   //获取批改记录详情
  {
    url: '/yc/fc/nsp-uwci/policyInfoDetails',
    name: 'policyInfoDetails'
  },
   // //获取批改记录
   {
    url: '/yc/fc/nsp-uwci/carPolicyEndor',
    name: 'carPolicyEndor'
  },
  // 获取自主验车短链接
  {
    url: '/official/vehicleInspectionGetShortLinks',
    name: 'vehicleInspectionGetShortLinks'
  },
  // 记录验车埋点接口
  {
    url: '/official/vehicleInspectionRecord',
    name: 'vehicleInspectionRecord'
  }
]
export default httpList
